"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

/** Persists GCLID from localStorage to profiles on new user signup */
export function GclidSync() {
  const searchParams = useSearchParams();
  const isNewUser = searchParams.get("new_user") === "1";

  useEffect(() => {
    if (!isNewUser) return;
    const gclid = localStorage.getItem("snapcards_gclid");
    if (!gclid) return;

    fetch("/api/profile/gclid", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ gclid }),
    }).catch(() => {});
  }, [isNewUser]);

  return null;
}
